import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=4e13252e&scoped=true"
import script from "./ProductMenu.vue?vue&type=script&lang=js"
export * from "./ProductMenu.vue?vue&type=script&lang=js"
import style0 from "./ProductMenu.vue?vue&type=style&index=0&id=4e13252e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13252e",
  null
  
)

export default component.exports